import { useState, useEffect } from 'react';
import ApiService from '../../../../services/api'
import DOMPurify from "dompurify";

const PrivacyPolicy = () => {
  

  const [privacyPolicy, setPrivacyPolicy] = useState('');

  useEffect(() => {
      const fetchPrivacyPolicy = async () => {
        try {
          const res = await ApiService.getLegal();
          setPrivacyPolicy(res.privacy_policy); 
        } catch (err) {
          console.error('Errore nel recupero della privacy policy:', err);
        }
      };
      fetchPrivacyPolicy();
    },[]);

    return (
        <div>
            <h2 style={{marginBottom: "50px", marginTop: "10px"}}>Privacy Policy</h2>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(privacyPolicy || "") }} />
        </div>

    );

  }

export default PrivacyPolicy;